import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import Landing from "./pages/Landing";
import PrototypeEditorial from "./pages/PrototypeEditorial";
import PrototypeActivist from "./pages/PrototypeActivist";
import PrototypeMinimal from "./pages/PrototypeMinimal";
import PrototypeCurated from "./pages/PrototypeCurated";
import PrototypeStories from "./pages/PrototypeStories";
import WhoAreWe from "./pages/WhoAreWe";
import SurvivorStory from "./pages/SurvivorStory";
import OurPlan from "./pages/OurPlan";
import OurProjects from "./pages/OurProjects";
import InTheNews from "./pages/InTheNews";
import SherifaFilm from "./pages/SherifaFilm";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PrototypeStories />} />
            <Route path="/who-we-are" element={<WhoAreWe />} />
            <Route path="/survivor-story" element={<SurvivorStory />} />
            <Route path="/our-plan" element={<OurPlan />} />
            <Route path="/our-projects" element={<OurProjects />} />
            <Route path="/in-the-news" element={<InTheNews />} />
            <Route path="/sherifa-film" element={<SherifaFilm />} />
            <Route path="/selector" element={<Landing />} />
            <Route path="/prototype-1" element={<PrototypeEditorial />} />
            <Route path="/prototype-2" element={<PrototypeActivist />} />
            <Route path="/prototype-3" element={<PrototypeMinimal />} />
            <Route path="/prototype-4" element={<PrototypeCurated />} />
            <Route path="/prototype-5" element={<PrototypeStories />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
